import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import Controls from '../../../../controls/Controls'
import { useForm, Form } from '../../../../controls/useForm'
import { request } from '../../../../../api/Service'
import { store } from '../../../../../redux-store/store'
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
// import StatComponent from '../../stat-page/StatComponent';
import 'react-toastify/dist/ReactToastify.css';
import { SettingsBackupRestoreOutlined } from '@material-ui/icons';
const initialFValues = {
  costPrice: 0,
  productName: '',
  quantity: 0,
  locationId: 0,
  quantity: 0,
  sku: '',
};

export default function AddInventoryForm(props) {
  const { addOrEdit, addInventory, recordForEdit, products, locations } = props;
  const [productName, setProductName] = useState('');
  const [transactionReference, setTtransactionReference] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [data, setData] = useState([]);
  const [salesPrice, setSalesPrice] = useState('');
  const [costPrice, setCostPrice] = useState('');
  const [sku, setSku] = useState('');
  const [location, setLocation] = useState(0);
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ('salesPrice' in fieldValues)
      temp.salesPrice =
        fieldValues.salesPrice > 0 ? '' : 'This field is required.';
    if ('quantity' in fieldValues)
      temp.quantity = fieldValues.quantity > 0 ? '' : 'This field is required.';
    if ('costPrice' in fieldValues)
      temp.costPrice =
        fieldValues.costPrice > 0 ? '' : 'This field is required.';
    if ('sku' in fieldValues)
      temp.sku = fieldValues.sku ? '' : 'This sku is required.';
    if ('locationId' in fieldValues)
      temp.locationId =
        fieldValues.locationId > 0 ? '' : 'Select a Location Type';
    if ('productId' in fieldValues)
      temp.productId =
        fieldValues.productId !== '' ? '' : 'Select a Product Type';
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === '');
  };
  const handleInputSalesChange = (e, v) => {
    if (e.target == null) {
      setSalesPrice(v);
    } else {
      setSalesPrice(e.target.value);
    }
  };
  const handleQuantityChange = (e, v) => {
    if (e.target == null) {
      setQuantity(v);
    } else {
      setQuantity(e.target.value);
    }
  };
  var locationIdValue = 0;

  const handleInputProductNameChange = (e, v) => {
    if (e.target == null) {
      setProductName(v);
    } else {
      setProductName(e.target.value);
    }
  };
  var updated_array = [];
  var updated = (data) => {
    for (var i = 0; i < data.length; i++) {
      updated_array.push({
        ...data[i], title: `Product:${data[i].productName}  Quantity:${data[i].quantity-data[i].quantityRefunded??0}`, id: data[i].productId
      })
    }
    setData(updated_array);
  }

  const handleInputTranChange = (e, v) => {
    if (e.target == null) {
      setSku(v);
    } else {


      setTtransactionReference(e.target.value);
      if (e.target.value.length > 5) {
        setTtransactionReference(e.target.value);
        setData([])
        request(
          'get',
          {},
          `api/SalesTransactionV2/get-orders?transactionReference=${e.target.value}`
        )
          .then((data) => {
            if (data.length > 0) {
              alert('Trnasaction Exist')
              updated(data)
            } else {
              alert("Order does not exist !!!!!")
            }
          }).catch(
            error => {
              alert("Order does not exist !!!!!")
            }
          );
      }
    }
  };



  var get_product = () => {
    console.log(
      `get-web-product-by-sku-location?sku=${sku}&locationId=${localStorage.getItem(
        'locationIdValue'
      )}`
    );

    if (
      localStorage.getItem('locationIdValue') > 0 &&
      localStorage.getItem('skuValue') != ''
    ) {
      console.log(
        `get-web-product-by-sku-location?sku=${localStorage.getItem(
          'skuValue'
        )}&locationId=${localStorage.getItem('locationIdValue')}`
      );
      request(
        'get',
        {},
        `get-web-product-by-sku-location?sku=${localStorage.getItem('skuValue')}&locationId=${localStorage.getItem(
          'locationIdValue'
        )}`
      ).then((data) => {
        if (data.productName != null) {
          handleInputSalesChange('', data.salesPrice);
          handleInputProductNameChange('', data.productName);
          // handleInputProductDescriptionChange('', data.productDescription);
          handleInputTranChange('', data.sku);
          handleQuantityChange('', data.costPrice);
        } else {
          handleInputSalesChange('', '');
          handleInputProductNameChange('', '');
          //  handleInputProductDescriptionChange('', '');
          handleQuantityChange('', '');
        }
      });
    }
  };
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate, get_product);
  const handleSubmit = (e) => {
    e.preventDefault();
    for (var i = 0; i < data.length; i++) {
      if (data[i].productId == values.productId) {
        store.dispatch({ type: 'ADD_ITEM_TO_REFUND', payload:{
          ... data[i] ,quantityRefunded:quantity
        }});
      }
    }

  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);
  // Added
  const top100Films = [
    { label: 'The Shawshank Redemption' },
    { label: 'The Godfather' },
    { label: 'The Godfather: Part II' },
    { label: 'The Dark Knight' },
    { label: '12 Angry Men' },
    { label: "Schindler's List" },
    { label: 'Pulp Fiction' },
    {
      label: 'The Lord of the Rings: The Return of the King',
      year: 2003,
    },
  ]
  // Added
  return (
    <Form onSubmit={handleSubmit}>
      <ToastContainer />
      <Grid container>
        <Grid item xs={12}>
          <Controls.Input
            name="transactionRefernce"
            label="Transaction Reference"
            value={transactionReference}
            onChange={handleInputTranChange}
            error={errors.transactionReference}
          />
          <Controls.Select
            name="productId"
            label="Product*"
            value={values.productId || ''}
            onChange={handleInputChange}
            options={data}
            error={errors.productId}
          />
          <Controls.Input
            name="quantity"
            label="Quantity"
            value={quantity}
            onChange={handleQuantityChange}
            error={errors.quantity}
          />
        </Grid>
        <div>
          <Controls.Button type="submit"
            text="Submit" />
        </div>
      </Grid>

    </Form>
  );
}
